import { Box, Typography, Grid2, Table, TableHead, TableRow, TableCell, TableBody, Paper } from "@mui/material";
import CustomDivider from "../../../shared/utils/CustomDivider";

const PublisherDetails = ({ publisher }) => {

    return (
        <Box sx={{ p: 2, bgcolor: "#fff", borderRadius: 1 }}>

            {/* ---------- Publications ---------- */}
            <Typography fontWeight={600} mb={1}>
                Added Publications
            </Typography>

            <Paper variant="outlined" sx={{ mb: 2 }}>
                <Table size="small" sx={{ padding: 2 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell width={80}>Sl No</TableCell>
                            <TableCell>Publications</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {publisher?.publications?.length ? (
                            publisher.publications.map((pub, i) => (
                                <TableRow key={pub.id}>
                                    <TableCell>{i + 1}</TableCell>
                                    <TableCell>{pub.publication_name}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={2}>No Publications</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Paper>

            {/* ---------- Basic Info Grid ---------- */}
            <Grid2 container spacing={2} mb={2}>
                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        Country : {publisher.country_name || "-"}
                    </Typography>

                </Grid2>
                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        State : {publisher.state_name || "-"}
                    </Typography>
                </Grid2>
                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        City : {publisher.city_name || "-"}
                    </Typography>
                </Grid2>
                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        Pincode : {publisher.pincode || "-"}
                    </Typography>
                </Grid2>
            </Grid2>
            <CustomDivider size={"0.5rem"} />
            <Grid2 container spacing={2} mb={2}>

                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        Board : {publisher.board || "-"}
                    </Typography>
                </Grid2>
                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        Year of Establishment : {publisher.year_of_establishment || "-"}
                    </Typography>
                </Grid2>
            </Grid2>
            <CustomDivider size={"0.5rem"} />
            <Grid2 container spacing={2} mb={2}>
                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        Grade : {publisher.grade || "-"}
                    </Typography>
                </Grid2>

                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        Level : {publisher.level || "-"}
                    </Typography>
                </Grid2>

                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        No Of Schools : {publisher.number_of_schools || "-"}
                    </Typography>
                </Grid2>
            </Grid2>
            <CustomDivider size={"0.5rem"} />
            <Grid2 container spacing={2} mb={2}>
                <Grid2 children size={{ xs: 6, md: 3 }}>
                    <Typography>
                        Quantity : {publisher.quantity || "-"}
                    </Typography>
                </Grid2>
            </Grid2>
            <CustomDivider size={"0.5rem"} />

            {/* ---------- Contact Persons ---------- */}
            <Typography fontWeight={600} mb={1}>
                Contact Person Details
            </Typography>

            <Paper variant="outlined">
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell width={80}>Sl No</TableCell>
                            <TableCell>Person In Charge</TableCell>
                            <TableCell>Mobile</TableCell>
                            <TableCell>Email</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {publisher?.persons?.length ? (
                            publisher.persons.map((p, i) => (
                                <TableRow key={p.id}>
                                    <TableCell>{i + 1}</TableCell>
                                    <TableCell>{p.name}</TableCell>
                                    <TableCell>{p.contact}</TableCell>
                                    <TableCell>{p.email}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={4}>No Contacts</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Paper>

        </Box>
    );
};

export default PublisherDetails;
